import React, { useState } from "react";
import Drawer from 'react-modern-drawer';
import ContractSearch from "../Projects/ContractSearch";
import projectServices from "../Projects/projectServices";

export default function ContractCompare(projectDetails: any) {
    const [isOpen, setIsOpen] = React.useState(false);
    const [searchResults, setSearchResults] = useState<any>([]);
    const [searchData, setSearchData] = useState<any>('');

   // console.log(searchResults)
    const toggleDrawer = () => {
        setIsOpen(!isOpen)
    }

    const handleSearchResults = (response: any, searchData: any) => {
        setSearchResults(response);
        setSearchData(searchData);
       // console.log('API response:', response);
       // console.log('Search data:', searchData);
    };

    const handleExport = (exportData: any) => {
        

        const data = {
            projectId: projectDetails.projectDetails.projectId,
            type: 'Compare',
            GroupBy: searchData.GroupBy,
            contractType:searchData.contractType ,
            export: 1
            
        };
        
        projectServices.financialPerformanceCompareExport(data)
            .then((response) => {
               // console.log('export done', response);
            });

    };

    return (
        <div>
            <button className="icon-btn edit pull-right btn-sm" onClick={() => setIsOpen(true)}>
                <i className="icon-alpha"></i>
            </button>

            <Drawer open={isOpen} onClose={toggleDrawer} direction="right" className="react-drawer allowVscroll allowHscroll" style={{ width: "100%" }}>
                <div className="box noBorderRadius noBorder ws-8 pull-right">

                    <div className="box-header  noBorderRadius bg-blue pLarge">
                        Contract Compare
                    </div>

                    <div className="ws-12 landing">

                        <div className="ws-3 pm">
                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                <label className="ws-12 text-left mts text-bold">Project title:</label>
                                <div className="label-entries text-right ws-12 text-m mtl mb">
                                    {projectDetails.projectDetails.projectName}
                                </div>
                            </div>
                        </div>

                        <div className="ws-3 pm">
                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                <label className="ws-12 text-left mts text-bold">Project code:</label>
                                <div className="label-entries text-right ws-12 text-m mtl mb">
                                    {projectDetails.projectDetails.projectCode}
                                </div>
                            </div>
                        </div>

                        <div className="ws-3 pm">
                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                <label className="ws-12 text-left mts text-bold">Project Owner:</label>
                                <div className="label-entries text-right ws-12 text-m mtl mb">
                                    {projectDetails.projectDetails.projectOwner ? (projectDetails.projectDetails.projectOwner) : (<>&nbsp;</>)}
                                </div>
                            </div>
                        </div>


                        <div className="ws-3 pm">
                            <div className="pLarge topFrame topFrame_paleBlue ws-12 pull-left">
                                <label className="ws-12 text-left mts text-bold">Project Status:</label>
                                <div className="label-entries text-right ws-12 text-m mtl mb">
                                    {projectDetails.projectDetails.statusDescription}
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="ws-12" >

                        <div >
                            <ContractSearch projectDetails={projectDetails.projectDetails} onSearchResults={handleSearchResults}/>
                        </div>

                        <div className="ws-12 pm">
                            <div className="box">

                                <div className="box-header">
                                    <h2>Contract Compare</h2>
                                </div>

                                <div className="box-content pt">
                                    <div className="table-responsive allowHscroll allowVscroll min-height500">

                                        {searchResults.length > 0 && (
                                            <table>
                                                <thead>
                                                    <tr className="text-bold">

                                                        <td>{searchData.GroupBy}</td>
                                                        {Object.keys(searchResults[0].column).map((key) => (
                                                            <td key={key}>{key}</td>
                                                        ))}

                                                        <td className="text-right">Total</td>

                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    {searchResults.map((result: any, index: any) => (
                                                        <tr key={index}>
                                                            <td>{result.ItemCode}</td>

                                                            {Object.values(result.column).map((value: any, keyIndex: any) => (
                                                                <td className="text-right" key={keyIndex}>

                                                                    {
                                                                        value === 'Indie' ? (<button className="btn icon-btn warning pull-right">Indie</button>)
                                                                            : value === 'Main' ? (<button className="icon-btn edit pull-right">Main</button>)
                                                                                : value === 'Sub' ? (<button className="icon-btn info pull-right">Sub</button>)
                                                                                    : (value)
                                                                    }

                                                                </td>

                                                            ))}

                                                            <td className="text-right">{result.rowTotal}</td>

                                                        </tr>
                                                    ))}

                                                    <tr>
                                                        <td className="text-bold">Total</td>
                                                        {Object.keys(searchResults[0].column).map((key) => (
                                                            <td key={key}></td>
                                                        ))}

                                                        <td className="text-right text-bold">
                                                            {searchResults.reduce((sum: any, result: any) => sum + result.rowTotal, 0)}
                                                        </td>
                                                    </tr>

                                                </tbody>

                                            </table>
                                        )}

                                        {searchResults.length === 0 && (
                                            <div className="alert">
                                                No results found for these criteria
                                            </div>
                                        )}

                                    </div>

                                   

                                </div>

                                
                            </div>
                            {searchResults.length > 0 && (
                                    
                                    <div className="box-footer">
                                        <button className="icon-btn edit pull-right" onClick={handleExport}>Export</button>

                                    </div>
                                    )
                                    }
                        </div>
                    </div>

                    

                    <div className="box-footer">
                        <button className="icon-btn delete pull-right" onClick={() => toggleDrawer()}>Close</button>
                    </div>
                </div>
            </Drawer>
        </div>

    )
}